import { useParams, Link } from 'react-router-dom';
import { Spinner } from '@/components/ui/Spinner';
import { RollPositionForm } from '@/components/positions/RollPositionForm';
import { usePosition } from '@/hooks/queries/usePositions';
import { useChain } from '@/hooks/queries/useChains';

export function RollPositionPage() {
  const { id } = useParams<{ id: string }>();
  const { data: position, isLoading: positionLoading } = usePosition(id || '');

  const chainId = position?.tradeChainId;
  const { data: chain, isLoading: chainLoading } = useChain(chainId || '');

  if (!id) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500">Position not found</p>
        <Link to="/chains" className="text-brand-600 hover:text-brand-700 mt-2 inline-block">
          Back to chains
        </Link>
      </div>
    );
  }

  if (positionLoading || chainLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!position || !chain) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500">Position not found</p>
        <Link to="/chains" className="text-brand-600 hover:text-brand-700 mt-2 inline-block">
          Back to chains
        </Link>
      </div>
    );
  }

  if (position.status !== 'open') {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500">Position is already closed</p>
        <Link
          to={`/chains/${chain.id}`}
          className="text-brand-600 hover:text-brand-700 mt-2 inline-block"
        >
          Back to chain
        </Link>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <Link
          to={`/chains/${chain.id}`}
          className="inline-flex items-center text-sm text-gray-500 hover:text-gray-700 mb-4"
        >
          <svg className="w-4 h-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Back to {chain.underlyingSymbol}
        </Link>
        <h1 className="text-2xl font-bold text-gray-900">
          Roll {chain.underlyingSymbol} Position
        </h1>
        <p className="text-sm text-gray-500 mt-1">
          Close your current position and open a new one in a single transaction
        </p>
      </div>

      <RollPositionForm
        position={position}
        chainId={chain.id}
        underlyingSymbol={chain.underlyingSymbol}
      />
    </div>
  );
}
